import { Component, inject } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { Store } from '@ngrx/store';
import { selectBackendVersion, selectFrontendVersion } from '../shared/store/app';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-footer',
  standalone: false,
  templateUrl: './app.footer.component.html'
})
export class AppFooterComponent {
  public layoutService = inject(LayoutService);
  private store = inject(Store);

  public currentYear = new Date().getFullYear();
  public frontendVersion = 'Local';
  public backendVersion = 'Local';
  constructor() {
    this.store
      .select(selectFrontendVersion)
      .pipe(takeUntilDestroyed())
      .subscribe((data) => {
        this.frontendVersion = data;
      });

    this.store
      .select(selectBackendVersion)
      .pipe(takeUntilDestroyed())
      .subscribe((data) => {
        this.backendVersion = data;
      });
  }

  get colorScheme(): string {
    return this.layoutService.config.colorScheme;
  }
}
